var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ContactsService } from './shared/services/contacts.service';
import { getContactsColsSelector, getContactsTotalSelector, getEventsOptionSelector, getRawContactsColumnsSelector, getTempPageSelector } from './contacts.reducer';
import { ContactsReports } from './reports/contacts.report';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import { ToggleContactsTableAction } from './contacts.actions';
import { getLimitsSelector } from '../shared/limits/limits.reducer';
import { NotificationService } from '../shared/notification.service';
import { DatePickerService } from '../shared/services/date.picker.service';
var ContactsComponent = /** @class */ (function () {
    function ContactsComponent(store, contactsService, datePickerService, contactsReports, notificationService) {
        this.store = store;
        this.contactsService = contactsService;
        this.datePickerService = datePickerService;
        this.contactsReports = contactsReports;
        this.notificationService = notificationService;
        this.utcOffset = moment().utcOffset();
        this.hasDataToExport = false;
        this.defaultFilterRange = {
            start: moment().subtract(7, 'day').startOf('day').add(this.utcOffset / 60, 'hours').toISOString(),
            end: moment().endOf('day').add(this.utcOffset / 60, 'hours').toISOString()
        };
    }
    ContactsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.store.select(getLimitsSelector).subscribe(function (limits) {
            _this.minDate = _this.contactsService.calculateMinDateByLimit(limits.callsHistoryLimit, _this.utcOffset);
            _this.contactsService.onChangeRange({
                dateFrom: _this.startDate
                    ? _this.getAcceptableStartDate(_this.startDate, _this.minDate)
                    : _this.defaultFilterRange.start,
                dateTo: _this.endDate ? _this.endDate : _this.defaultFilterRange.end
            });
        });
        this.store.select(getTempPageSelector).subscribe(function (tempPage) {
            _this.tempPageFilters = tempPage;
            if (_this.tempPageFilters && tempPage.filter) {
                _this.startDate = tempPage.filter.dateFrom
                    ? _this.getAcceptableStartDate(tempPage.filter.dateFrom, _this.minDate)
                    : _this.minDate;
                _this.endDate = tempPage.filter.dateTo;
                _this.phrase = tempPage.filter.fullTextSearchPhrase;
            }
            else {
                _this.startDate = _this.defaultFilterRange.start;
                _this.endDate = _this.defaultFilterRange.end;
            }
        });
        this.store.select(getContactsColsSelector).subscribe(function (columns) {
            _this.columns = columns;
        });
        this.store.select(getRawContactsColumnsSelector).subscribe(function (rawColumns) {
            _this.rawColumns = rawColumns;
        });
        this.store.select(getEventsOptionSelector).subscribe(function (isEventsTable) {
            _this.isEventsTable = isEventsTable ? isEventsTable : false;
            if (isEventsTable === undefined) {
                _this.store.dispatch(new ToggleContactsTableAction(_this.isEventsTable));
                _this.setDefaultViewToEvents();
            }
        });
        this.datePickerService.onTogglePicker.subscribe(function (open) {
            _this.opens = open && open.open ? open.open : 'right';
            _this.datepickerVisible = open && open.show ? open.show : false;
        });
        this.store.select(getContactsTotalSelector).subscribe(function (total) {
            _this.hasDataToExport = !!total;
        });
        this.contactsService.getPossibleMinDate().subscribe(function (response) {
            _this.minReportDate =
                response && response.earliestReportDate ? moment(response.earliestReportDate).toISOString() : null;
        });
        this.contactsService.closeAllFilters();
        this.maxDate = moment().endOf('day').add(this.utcOffset / 60, 'hours').toISOString();
        this.startDate = this.getAcceptableStartDate(this.startDate, this.minDate);
    };
    ContactsComponent.prototype.getAcceptableStartDate = function (startDate, minDate) {
        return startDate && minDate ? (moment(startDate).isSameOrAfter(minDate) ? startDate : minDate) : this.minDate;
    };
    ContactsComponent.prototype.createRequestParams = function () {
        return {
            columns: this.rawColumns.map(function (item) {
                var name = item.name.replace('CONTACTS_LIST.', '');
                return __assign({}, item, { name: name });
            }),
            date: moment().toISOString(),
            filter: __assign({}, this.tempPageFilters.filter),
            sorting: {
                order: this.tempPageFilters.pagination.order,
                sorting: this.tempPageFilters.pagination.sortBy
            },
            timezoneOffsetMinutes: moment().utcOffset()
        };
    };
    ContactsComponent.prototype.getContactsReport = function () {
        this.contactsReports.getContactsReport(this.createRequestParams()).subscribe(function (response) {
            var currentDateName = moment()
                .format()
                .split('+')[0]
                .replace('T', '_');
            var fileName = "contacts_" + currentDateName + ".xlsx";
            var blob = new Blob([response], { type: 'application/x-ms-excel' });
            saveAs(blob, fileName);
        });
    };
    ContactsComponent.prototype.toggleTable = function () {
        this.isEventsTable = !this.isEventsTable;
        this.store.dispatch(new ToggleContactsTableAction(this.isEventsTable));
    };
    ContactsComponent.prototype.changeDateRange = function (event) {
        // from contacts-table...
        if (moment(event.dateFrom).isSameOrAfter(this.minDate)) {
            var data = __assign({}, this.tempPageFilters, { filter: __assign({}, this.tempPageFilters.filter, { dateFrom: moment(event.dateFrom), dateTo: moment(event.dateTo), contactId: this.tempPageFilters.filter.contactId }), filters: {
                    dateFrom: moment(event.dateFrom).toISOString(),
                    dateTo: moment(event.dateTo).toISOString()
                } });
            this.contactsService.onChangeRange(event);
            this.contactsService.fetchDataAction(data, 0);
            this.contactsService.rowCollapse();
        }
        else {
            this.notificationService.open('REPORT_NOT_IN_BACKWARD_DAYS_RANGE');
        }
    };
    ContactsComponent.prototype.setPhrase = function (phrase) {
        this.contactsService.searchByPhrase(phrase === '' ? null : phrase);
    };
    ContactsComponent.prototype.searchByPhrase = function () {
        this.contactsService.fetchDataAction(this.tempPageFilters, 0);
    };
    ContactsComponent.prototype.clearFilterWhenEmpty = function (phrase) {
        if (!phrase) {
            this.searchByPhrase();
        }
    };
    // Cannot use event's table as default view, because all css classes are
    // defined in the contacts-table.component.scss file, and ContactsTableComponent
    // uses ViewEncapsulation.None to propagate these styles to the EventsTableComponent,
    // so ContactsTableComponent (default isEventsTable = false) must be used before
    // EventsTableComponent to ensure all styles are properly loaded.
    ContactsComponent.prototype.setDefaultViewToEvents = function () {
        var _this = this;
        setTimeout(function () {
            _this.isEventsTable = true;
            _this.store.dispatch(new ToggleContactsTableAction(_this.isEventsTable));
        }, 0);
    };
    return ContactsComponent;
}());
export { ContactsComponent };
